<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增规则</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="600" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="85">

              <FormItem label="预约时间起" prop="start_date">
                <DatePicker  type="datetime" editable v-model="formValidate.start_date" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择时间" ></DatePicker>
              </FormItem>

              <FormItem label="预约时间至" prop="end_date">
                <DatePicker  type="datetime" editable v-model="formValidate.end_date" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择时间" ></DatePicker>
              </FormItem>
              <FormItem label="可预约数（上午）" prop="am_count">
                <Input
                  v-model="formValidate.am_count"
                  :maxlength="10"
                  placeholder="请输入可预约数量"
                ></Input></FormItem>
              <FormItem label="可预约数（下午）" prop="pm_count">
                <Input
                  v-model="formValidate.pm_count"
                  :maxlength="10"
                  placeholder="请输入可预约数量"
                ></Input></FormItem>
              <FormItem label="预约类型" prop="type">
                <Select  v-model="formValidate.type" placeholder="请选择类型" filterable>
                  <Option v-for="item in typeList" :value="item.value" :key="item.id">{{item.meaning}}</Option>
                </Select>
              </FormItem>
              <FormItem label="预约开放时间" prop="do_time">
                <DatePicker  type="datetime" editable v-model="formValidate.do_time" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择时间" ></DatePicker>
              </FormItem>

              <FormItem>

                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

  import {
    getpersonnelconfig,
    operationpersonnelconfig
  } from '@/api/personnel/personnel.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'
  let moment = require('moment')
  export default {

    data () {
      return {
        spinShow: false,
        fullscreenLoading: false,
        exportLoading: false,
        index: 1,
        loading: false,
        logModal: false,
        typeList: [],
        formValidate: {
          Id: 0,
          start_date: '',
          end_date: '',
          am_count: 0,
          pm_count: 0,
          flag: 1,
          type: 0,
          do_time: ''
        },
        searchVal: '',
        single: false,
        loadingStatus: false,
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,

            align: 'center'
          },
          {
            title: '预约日期起',
            key: 'start_date',
            width: 170,

            align: 'center',
            sortable: true
          },
          {
            title: '预约日期止',
            key: 'end_date',
            width: 170,

            align: 'center',
            sortable: true
          },
          {
            title: '可预约数（AM）',
            key: 'am_count',
            width: 150,

            align: 'center',
            sortable: true
          },
          {
            title: '可预约数（PM）',
            key: 'pm_count',
            width: 150,

            align: 'center',
            sortable: true
          },
          {
            title: '预约开放日期',
            key: 'do_time',
            width: 170,
            align: 'center',
            sortable: true
          },
          {
            title: '预约类型',
            key: 'type_CN',
            width: 120,
            align: 'center',
            sortable: true
          },
          {
            title: '状态',
            key: 'flag_CN',
            width: 80,
            align: 'center',
            sortable: true
          },
          {
            title: '操作',
            key: 'handle',
            width: 130,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'post', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],

          start_date: [
            {
              required: true,
              type: 'date',
              message: '开始时间不能为空',
              trigger: 'blur'
            }
          ],
          end_date: [
            {
              required: true,
              type: 'date',
              message: '结束时间不能为空',
              trigger: 'blur'
            }
          ],
          Jtype: [
            {
              required: true,
              message: '请选择类型',
              trigger: 'change'
            }
          ],
          do_time: [
            {
              required: true,
              type: 'date',
              message: '开放时间不能为空',
              trigger: 'blur'
            }
          ]

        }
      }
    },
    methods: {
      delData (params) {
        if (confirm(`确定要删除这条记录？`)) {
          // console.log(params.row.id)
          operationpersonnelconfig(
            {
              'id': params.row.id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },
      getpersonnelconfig (key, value) {
        // console.log(this.columns[7].filters)
        this.spinShow = true
        getpersonnelconfig(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            // console.log(this.columns[6].filters)
            this.pageTotal = res.data.count
            this.tableData = res.data.data
            // this.columns[8].filters=res.data.police_station_CN;
            // this.columns[9].filters=res.data.idc_CN;
            // this.columns[10].filters=res.data.tv_station_CN;
            // console.log(this.columns[7].filters)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.id)
        })

        this.tableSelectIdList = SelectIdList
      },

      editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth
        this.getpersonnelconfig()
        this.gettypeList()
        var day2 = new Date()
        day2.setTime(day2.getTime())
        var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
        if (paramsRow && paramsRow.id) {
          this.formValidate = {
            id: paramsRow.id,
            start_date: paramsRow.start_date,
            end_date: paramsRow.end_date,
            am_count: paramsRow.am_count,
            pm_count: paramsRow.pm_count,
            flag: paramsRow.flag,
            type: paramsRow.type.toString(),
            do_time: paramsRow.do_time
          }
        } else {
          this.formValidate = {
            Id: 0,
            start_date: s2,
            end_date: s2,
            am_count: 35,
            pm_count: 45,
            flag: 1,
            type: 1,
            do_time: s2
          }
        }
      },
      handleSubmit (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              this.formValidate.start_date = moment(this.formValidate.start_date).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              this.formValidate.end_date = moment(this.formValidate.end_date).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              this.formValidate.do_time = moment(this.formValidate.do_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
              operationpersonnelconfig(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getpersonnelconfig()

                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数')
          }
        })
      },

      handleReset (name) {
        this.$refs[name].resetFields()
      },

      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中数据`)) {
            operationpersonnelconfig({ 'id_list': this.tableSelectIdList }, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getpersonnelconfig()
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },

      handleSearch () {
        this.getpersonnelconfig(this.searchVal)
      },
      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getpersonnelconfig(this.searchVal)
        } else {
          this.getpersonnelconfig()
        }
      },
      gettypeList () {
        getsysparameterList('personnel_info', 'type').then(res => {
          if (res.data.code === 0) {
            this.typeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getpersonnelconfig(this.searchVal)
        } else {
          this.getpersonnelconfig()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getapplylist(this.searchVal)
        } else {
            this.getpersonnelconfig()
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted () {
      this.getpersonnelconfig()
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
